import {
  createPolyclinic,
  updatePolyclinic,
  getPolyclinicById,
  getPolyclinics,
} from "@/services/admin/polyclinics";

export const state = {
  polyclinics: [],
  currentPolyclinic: {
    nameId: "",
    nameEn: "",
    icon: "",
    status: "",
  },
  formData: {
    nameId: "",
    nameEn: "",
    icon: "",
    status: "",
  },
  isUploading: false,
};

export const mutations = {
  SET_POLYCLINICS(state, polyclinics) {
    state.polyclinics = polyclinics;
  },
  SET_CURRENT_POLYCLINIC(state, polyclinic) {
    state.currentPolyclinic = polyclinic;
    // Juga update formData
    state.formData = { ...polyclinic };
  },
  UPDATE_FORM_DATA(state, { field, value }) {
    state.formData = {
      ...state.formData,
      [field]: value,
    };
  },
  SET_UPLOADING_STATUS(state, status) {
    state.isUploading = status;
  },
  RESET_FORM(state) {
    state.formData = {
      nameId: "",
      nameEn: "",
      icon: "",
      status: "",
    };
  },
};

export const actions = {
  async fetchPolyclinics({ commit }) {
    try {
      const response = await getPolyclinics(1, 1000);
      commit("SET_POLYCLINICS", response.data.data);
    } catch (error) {
      console.error("Failed to fetch polyclinics:", error);
      throw error;
    }
  },

  async loadPolyclinicById({ commit }, id) {
    try {
      const response = await getPolyclinicById(id);
      const polyclinic = {
        nameId: response.data.nameId,
        nameEn: response.data.nameEn,
        icon: response.data.icon,
        status: response.data.status,
      };
      commit("SET_CURRENT_POLYCLINIC", polyclinic);
    } catch (error) {
      console.error("Failed to load polyclinic:", error);
      throw error;
    }
  },

  async savePolyclinic({ commit }, { id = null, formData }) {
    try {
      console.log("Saving polyclinic with data:", formData);

      // Gunakan formData yang dikirim dari component
      if (id) {
        await updatePolyclinic(id, formData);
      } else {
        await createPolyclinic(formData);
      }

      commit("RESET_FORM");
      return true;
    } catch (error) {
      console.error("Failed to save polyclinic:", error);
      throw error;
    }
  },
  updateFormField({ commit }, { field, value }) {
    commit("UPDATE_FORM_DATA", { field, value });
  },
};

export const getters = {
  isNameIdDuplicate: (state) => (nameId) => {
    return state.polyclinics.some(
      (poly) => poly.nameId.toLowerCase() === nameId.toLowerCase()
    );
  },
  isNameEnDuplicate: (state) => (nameEn) => {
    return state.polyclinics.some(
      (poly) => poly.nameEn.toLowerCase() === nameEn.toLowerCase()
    );
  },
};
